import React from "react";
import { cn } from "@/lib/utils";

const TONES = {
  copper: "bg-copper-light/60 border-copper/20",
  success: "bg-success-bg border-success/20",
  warning: "bg-warning-bg border-warning/20",
  info: "bg-info-bg border-info/20",
  danger: "bg-danger-bg border-danger/20",
  plain: "bg-card border-line",
};

export function MetricCard({ label, value, hint, tone = "plain", icon: Icon, onClick, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={cn(
        "text-left rounded-xl border p-4 transition-all duration-150",
        TONES[tone],
        onClick && "hover:border-copper/40 hover:shadow-sm cursor-pointer"
      )}
    >
      <div className="flex items-start justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-ink-2">{label}</span>
        {Icon && <Icon className="h-4 w-4 text-ink-muted" />}
      </div>
      <div className="mt-2 font-display text-3xl font-semibold text-ink leading-none">{value}</div>
      {hint && <div className="mt-1.5 text-xs text-ink-2">{hint}</div>}
    </button>
  );
}
